import commonHelpers from './common-helpers.es6'

const itemsHelpers = {
  mixins: [commonHelpers],
  data: function () {
    return {
      model: {
        name: '',
        tree: false,
        limit: 1000, // limit the amount of records returned by index from BE
        offset: 0, // used by infinity scroll (and alternatives)
        archive: false // When true, index returns archived items
      },
      customParams: {},
      loadOnStart: true,
      hasInfinityLoading: false, // used by infinity loading
      // hasShowMoreLoading: false, // used by showMore loading (flag not needed)
      hasNoMoreItemsToLoad: false, // used to hide showMore button in showMore loading
      infinityLimit: 50, // number of records (page size) to be loaded on infinity scroll
      initialInfinityLimit: 50, // number of records to pre-load on pages with infinity scroll
      loading: false, // used by infinity loading
      pageLoaded: false, // used by infinity loading
      auxModels: [], // any auxilliary models
      dataLoaded: false,
      search: ''
    }
  },
  created () {
    if (this.loadOnStart)
      this.storeUpdate()
  },
  mounted () {
    this.pageLoaded = true // used by infinity loading and by gmaps
  },
  computed: {
    items () {
      return this.$store.state.items[this.model.name]
    },
    itemsLoaded () {
      return this.$store.state.itemsLoaded[this.model.name]
    }
  },
  methods: {
    // Computations
    // ---
    // Loaders
    async storeUpdate () {
      if (this.hasInfinityLoading) {
        // this.$store.commit('resetItemsLoaded', {model: this.model})
        // this.$store.dispatch('getManyItems', {model: this.model, offset: 0, limit: this.initialInfinityLimit})
        //   .then(() => this.dataLoaded = true)
        throw new Error('[items-helpers] Infinity loading has been deprecated.')
      } else {
        this.dataLoaded = false
        try {
          await Promise.all([
            // items
            this.$store.dispatch('getItems', { model: this.model, customParams: this.customParams }),
            // auxes
            this.auxModels.map(model => this.$store.dispatch('getItems', { model }))
          ])
          this.hasNoMoreItemsToLoad = this.loadedLessItemsThanLimit(this.items.length)
          this.beforeDataLoaded() // Data loaded, dataLoaded still false
          this.dataLoaded = true
          this.afterDataLoaded() // Data loaded, dataLoaded already true
        } catch (error) {
          console.error(error)
        }
      }
    },
    async storeGetManyItems () {
      this.model.offset += this.model.limit
      // Load data from BE
      const response = await this.$store.dispatch('getManyItems', {
        model: this.model,
        customParams: this.customParams
      })
      // Hide showMore if no more data are available from BE
      this.hasNoMoreItemsToLoad = this.loadedLessItemsThanLimit(response && response.data && response.data.length)
    },
    beforeDataLoaded () {
      // To be inherited
    },
    afterDataLoaded () {
      // To be inherited
    },
    async filterByCustomParam (customParams) {
      this.model.offset = 0
      this.customParams = Object.assign(this.customParams, customParams)
      try {
        // Call for new data
        const response = await this.$store.dispatch('getItems', {
          model: this.model,
          customParams: this.customParams
        })
        // Hide showMore if no more data are available from BE
        this.hasNoMoreItemsToLoad = this.loadedLessItemsThanLimit(response && response.data && response.data.length)
      } catch (error) {
        console.error(error)
      }
    },
    loadedLessItemsThanLimit (lastLoadedItemQty) {
      return (lastLoadedItemQty < this.model.limit)
    },
    compareByStringKey (x, y, key) {
      if (x[key] < y[key]) {
        return -1
      }
      if (x[key] > y[key]) {
        return 1
      }

      return 0
    },
    saveItem (item, { reRoute = true, spinner = true, snackbar = true }) {
      return this.$store.dispatch('updateItem', { modelName: this.model.name, item: item })
        .then((response) => {
          if (response && response.status >= 200 && response.status <= 299) {
            if (reRoute) {
              this.reRoute()
            } else {
              // Clear any validation errors after successful save
              this.$store.commit('setErrors', { modelName: this.model.name, errors: {} })
            }
            // Snackbar after succesful save (must come after re-routing)
            if (snackbar) {
              this.$store.commit('setFlat', { param: 'savedSnackbar', val: true })
            }
          }
          return response
        })
    }
  }
}

export default itemsHelpers
